/**
 * Busca informações de CEP usando a API ViaCEP
 * Com fallback para API alternativa em caso de erro
 */
export const buscarCEP = async (cep) => {
  const cepLimpo = cep.replace(/\D/g, '');
  
  if (cepLimpo.length !== 8) {
    return null;
  }

  // Tentar ViaCEP primeiro
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000); // Timeout de 5 segundos
    
    const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`, {
      signal: controller.signal,
      headers: {
        'Accept': 'application/json',
      }
    });
    
    clearTimeout(timeoutId);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    if (data.erro) {
      return null;
    }

    return {
      cep: data.cep,
      rua: data.logradouro || '',
      bairro: data.bairro || '',
      cidade: data.localidade || '',
      estado: data.uf || ''
    };
  } catch (error) {
    // Se ViaCEP falhar, tentar API alternativa
    if (error.name === 'AbortError') {
      console.warn('Timeout ao buscar CEP na ViaCEP, tentando API alternativa...');
    } else {
      console.warn('Erro ao buscar CEP na ViaCEP, tentando API alternativa...', error.message);
    }
    
    // Fallback: Tentar API alternativa (BrasilAPI)
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 5000);
      
      const response = await fetch(`https://brasilapi.com.br/api/cep/v1/${cepLimpo}`, {
        signal: controller.signal,
        headers: {
          'Accept': 'application/json',
        }
      });
      
      clearTimeout(timeoutId);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      return {
        cep: data.cep || cepLimpo.replace(/(\d{5})(\d{3})/, '$1-$2'),
        rua: data.street || '',
        bairro: data.neighborhood || '',
        cidade: data.city || '',
        estado: data.state || ''
      };
    } catch (fallbackError) {
      console.error('Erro ao buscar CEP em ambas as APIs:', fallbackError);
      // Retornar null silenciosamente para não quebrar a aplicação
      return null;
    }
  }
};




